import Vue from 'vue'
import axios from 'axios'
import VueRouter, { RouteConfig } from 'vue-router'
import Login from '../components/appmart/login.vue'
import appmartDash  from '../components/appmart/appmartDash.vue'
import passReset from '@/components/appmart/passReset.vue'
import enrol from '@/components/appmart/enrol.vue'
import enroled from '@/components/appmart/enroled.vue'
import services from '@/components/appmart/services.vue'
import items from '@/components/appmart/items.vue'
import documents from '@/components/appmart/documents.vue'
import createstateAdmin from '@/components/appmart/createstateAdmin.vue'
import stateadminList from '@/components/appmart/stateadminList.vue'
import forgetPassword from '@/components/appmart/forgetPassword.vue'

let cancelSource = axios.CancelToken.source();


Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/forgetPassword',
    name: 'forgetPassword',
    component: forgetPassword
  },
  // {
  //   path: '/login',
  //   name: 'Loginnow',
  //   component: Login
  // },
  {
    path: '/appdashboard',
    name: 'dashboard',
    props: true,
    component: appmartDash,
    children: [
      {
        // UserProfile will be rendered inside User's <router-view>
        // when /user/:id/profile is matched
        path: '/enrol',
        name: 'enrol',
        component: enrol,
        props: true,
      
        // beforeEnter: Listresolver,
      }, {
        // UserProfile will be rendered inside User's <router-view>
        // when /user/:id/profile is matched
        path: '/enroled',
        name: 'enroled',
        component: enroled
      },
      {
        // UserProfile will be rendered inside User's <router-view>
        // when /user/:id/profile is matched
        path: '/services',
        name: 'services',
        component: services
      },{
        // UserProfile will be rendered inside User's <router-view>
        // when /user/:id/profile is matched
        path: '/items',
        name: 'items',
        component: items
      },{
        // UserProfile will be rendered inside User's <router-view>
        // when /user/:id/profile is matched
        path: '/documents',
        name: 'documents',
        component: documents
      },
      {
        // UserProfile will be rendered inside User's <router-view>
        // when /user/:id/profile is matched
        path: '/stateadmin',
        name: 'stateadmin',
        component: createstateAdmin
      },
      {
        // UserProfile will be rendered inside User's <router-view>
        // when /user/:id/profile is matched
        path: '/listinstadmin',
        name: 'listinstadmin',
        component: stateadminList
      },
    ]
  },
  {
    path: '/appreset',
    name: 'appreset',
    component: passReset
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
